const BASEURL = 'https://blissiq.in';
// const BASEURL = 'http://localhost:3001';


export {BASEURL};
